$(document).ready(function () {
  // Unwrap bootstrap-touchspin so the parent theme's vertical ± stack is replaced
  // by our custom horizontal +/- buttons defined in product-add-to-cart.tpl.
  var $qty = $('#quantity_wanted');
  if ($qty.length) {
    var $tsWrap = $qty.closest('.bootstrap-touchspin');
    if ($tsWrap.length) {
      $tsWrap.replaceWith($qty);
    }
  }
  $(document).on('click', '.bes-qty-minus', function (e) {
    e.preventDefault();
    var $i = $('#quantity_wanted');
    if (!$i.length) return;
    var min = parseInt($i.attr('min'), 10) || 1;
    var v = parseInt($i.val(), 10);
    if (isNaN(v)) v = min;
    if (v > min) {
      $i.val(v - 1).trigger('input').trigger('change');
    }
  });
  $(document).on('click', '.bes-qty-plus', function (e) {
    e.preventDefault();
    var $i = $('#quantity_wanted');
    if (!$i.length) return;
    var v = parseInt($i.val(), 10);
    if (isNaN(v)) v = 1;
    $i.val(v + 1).trigger('input').trigger('change');
  });

  (function initShippingDrawer() {
    var $drawer = $('#bes-shipping-drawer');
    if (!$drawer.length) return;

    var rates = {};
    try { rates = JSON.parse($drawer.attr('data-bes-shipping-rates') || '{}'); } catch (e) {}
    var labels = ['Véhicule léger', 'Véhicule lourd', 'Poids lourd grue'];
    var rawLabels = $drawer.attr('data-bes-shipping-labels');
    if (rawLabels) {
      try {
        var parsed = JSON.parse(rawLabels);
        if (Array.isArray(parsed) && parsed.length) labels = parsed;
      } catch (e) {}
    }

    var $input = $drawer.find('[data-bes-shipping-input]');
    var $result = $drawer.find('[data-bes-shipping-result]');
    var $empty = $drawer.find('[data-bes-shipping-empty]');
    var $notFound = $drawer.find('[data-bes-shipping-notfound]');

    function setVisible($el, visible) {
      if (!$el || !$el.length) return;
      $el.attr('hidden', visible ? null : 'hidden');
    }

    function buildResult(zip, rate) {
      var html = '<p class="bes-shipping-lookup__result-title">Tarifs pour le ' + zip +
        '</p><ul class="bes-shipping-lookup__result-list">';
      for (var i = 0; i < rate.length; i++) {
        html += '<li><span class="bes-shipping-vehicle">' + labels[i] +
          '</span><span class="bes-shipping-price">' + rate[i] + ' €</span></li>';
      }
      html += '</ul>';
      return html;
    }

    function render(zip) {
      var $rows = $drawer.find('.bes-shipping-table tbody tr');
      $rows.removeClass('is-highlighted');
      if (!zip) {
        $result.empty();
        setVisible($result, false);
        setVisible($notFound, false);
        setVisible($empty, true);
        return;
      }
      var rate = rates[zip];
      if (!rate) {
        $result.empty();
        setVisible($result, false);
        setVisible($empty, false);
        setVisible($notFound, true);
        return;
      }
      setVisible($empty, false);
      setVisible($notFound, false);
      $result.html(buildResult(zip, rate));
      setVisible($result, true);
      $rows.each(function () {
        if ($(this).find('td').first().text().trim() === zip) {
          $(this).addClass('is-highlighted');
          $drawer.find('.bes-shipping-table-wrap').attr('open', '');
        }
      });
    }

    function openDrawer() {
      $drawer.addClass('is-open').attr('aria-hidden', 'false');
      $('body').css('overflow', 'hidden');
      setTimeout(function () { $input.trigger('focus'); }, 200);
    }
    function closeDrawer() {
      $drawer.removeClass('is-open').attr('aria-hidden', 'true');
      $('body').css('overflow', '');
    }

    $(document).on('click', '[data-bes-shipping-open]', function (e) {
      e.preventDefault();
      openDrawer();
    });
    $drawer.on('click', '[data-bes-shipping-close]', function () { closeDrawer(); });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $drawer.hasClass('is-open')) closeDrawer();
    });

    $input.on('input', function () {
      var raw = String(this.value || '').replace(/\D/g, '').slice(0, 5);
      if (raw !== this.value) this.value = raw;
      render(raw.length === 5 ? raw : '');
    });
  })();

  // ── Product page: multiply displayed price by qty + mobile sticky add-to-cart ──
  (function initProductTotalPrice() {
    var $current = $('.product-prices .current-price').first();
    var $sticky = $('[data-bes-sticky-price]');
    if (!$current.length && !$sticky.length) return;

    var currency = $current.attr('data-bes-currency')
      || $sticky.attr('data-bes-currency') || 'EUR';
    var formatter = null;
    try {
      formatter = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: currency});
    } catch (e) {}

    function format(amount) {
      if (formatter) return formatter.format(amount);
      return amount.toFixed(2).replace('.', ',') + ' €';
    }

    function getQty() {
      var q = parseInt($('#quantity_wanted').val(), 10);
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function update() {
      var $price = $('.product-prices .current-price .product-price').first();
      if (!$price.length) return;
      if ($price.data('besUnit') === undefined) {
        $price.data('besUnit', $price.text());
      }
      var unit = parseFloat($price.attr('content'));
      if (isNaN(unit)) return;
      var qty = getQty();
      var unitText = $price.data('besUnit');
      var display = qty > 1 ? format(unit * qty) : unitText;

      $price.text(display);
      $('[data-bes-sticky-price]').text(display);

      var realDisabled = $('#add-to-cart-or-refresh .bes-add-to-cart').prop('disabled');
      $('[data-bes-sticky-add]').prop('disabled', !!realDisabled);
    }

    update();
    $(document).on('input change', '#quantity_wanted', update);
    $(document).on('click', '.bes-qty-minus, .bes-qty-plus', function () {
      setTimeout(update, 0);
    });
    if (window.prestashop && prestashop.on) {
      prestashop.on('updatedProduct', function () {
        setTimeout(update, 0);
      });
    }

    $(document).on('click', '[data-bes-sticky-add]', function (e) {
      e.preventDefault();
      var $real = $('#add-to-cart-or-refresh .bes-add-to-cart');
      if ($real.length && !$real.prop('disabled')) {
        $real.trigger('click');
      }
    });
  })();

  var giftBlock = $('#input_gift').closest('.mt-3');
  giftBlock.hide();

  function toggleGiftBlock() {
    var checked = $('input[name^="delivery_option"]:checked');
    if (checked.length) {
      var carrierName = checked.closest('.delivery-option').find('.carrier-name').text().trim().toUpperCase();
      if (carrierName.indexOf('LIVRAISON') === -1) {
        giftBlock.hide();
      } else {
        giftBlock.show();
      }
    }
  }

  toggleGiftBlock();

  // Run when carrier selection changes
  $(document).on('change', 'input[name^="delivery_option"]', toggleGiftBlock);

  prestashop.on('updatedDeliveryForm', function () {
    giftBlock = $('#input_gift').closest('.mt-3');
    toggleGiftBlock();
  });
});



// WEBPACK FOOTER //
// ./js/custom.js